export enum CornerMarketsEnabledAttribute {
  Master = 836,
}
